<template>
  <div class="course_introduce">
    <div
      class="course_introduce_content"
      ref="content"
      :class="[isExpanded ? 'expanded' : 'not_expanded']"
    >
      <div class="evaluate_info flex Flexalign FlexBetween">
        <div class="flex Flexalign evaluate_info_left">
          <div class="evaluate_rate">
            {{ $Tools.scoreToStar(courseDetail.courseExtra?.appraiseScore) }}
          </div>
          <div
            class="flex flexcolumn Flexalign FlexjustifyStart evaluate_rate_box FlexStart"
          >
            <el-rate v-model="evaluateInfo.rate" size="large" disabled />
            <div>共{{ listTotal }}条评论</div>
          </div>
        </div>
        <div class="btn_evaluate cursor_pointer" @click="goEvaluate">去评价</div>
      </div>
      <div class="evaluate_list" v-if="listTotal">
        <div class="evaluate_one flex" v-for="(item, index) in evaluateList" :key="index">
          <div class="evaluate_one_left">
            <el-image class="avatar" :src="imgPath(item.buyerUserHeadImage)"></el-image>
          </div>
          <div class="evaluate_one_right flex-1">
            <div class="flex Flexalign evaluate_name">
              <div>{{ item.name }}</div>
              <div class="evaluate_rate">
                <el-rate v-model="item.score" allow-half size="small" disabled />
              </div>
            </div>
            <div class="evaluate_content">{{ item.content }}</div>
            <div class="evaluate_time flex Flexalign FlexBetween">
              <div>{{ item.createTime }}</div>
              <div class="reply_box flex Flexalign">
                <div
                  class="flex Flexalign cursor_pointer"
                  @click="addReply(item.appraiseId, 1)"
                >
                  <el-image class="reply_img" :src="imgPath('reply_icon.png')"></el-image>
                  <div class="reply_text">回复</div>
                </div>
                <div class="split_line"></div>
                <el-image
                  class="reply_img cursor_pointer"
                  :src="imgPath('like_icon.png')"
                  v-show="!item.isLiked"
                  @click="evaluateLike(item.appraiseId, index)"
                ></el-image>
                <el-image
                  class="reply_img cursor_pointer"
                  :src="imgPath('liked_icon.png')"
                  v-show="item.isLiked"
                  @click="evaluateLike(item.appraiseId, index)"
                ></el-image>
                <div class="reply_text">{{ item.likeNum }}</div>
              </div>
            </div>
            <div v-if="item.subEvaluateList.length">
              <div class="" v-for="(sitem, sindex) in item.subEvaluateList" :key="sindex">
                <div
                  class="flex Flexalign evaluate_name reply_info"
                  v-if="sitem.businessUserId"
                >
                  <el-image
                    class="avatar"
                    :src="imgPath(sitem.businessUserAvatar)"
                  ></el-image>
                  <div class="replyer_name">{{ sitem.businessUserName }}</div>
                  <div class="replyer_tag">老师</div>
                  <div class="reply_text">回复</div>
                  <div class="replyer_name">{{ sitem.targetBuyerUserName }}:</div>
                </div>
                <div class="flex Flexalign evaluate_name reply_info" v-else>
                  <el-image
                    class="avatar"
                    :src="imgPath(sitem.buyerUserHeadImage)"
                  ></el-image>
                  <div class="replyer_name">{{ sitem.buyerUserName }}</div>
                  <div class="reply_text">回复</div>
                  <div class="replyer_name">{{ sitem.targetBuyerUserName }}:</div>
                </div>
                <div class="evaluate_content reply_evaluate_content">
                  {{ sitem.content }}
                </div>
                <div class="evaluate_time reply_evaluate_time flex Flexalign FlexBetween">
                  <div>{{ sitem.createTime }}</div>
                  <div class="reply_box flex Flexalign">
                    <el-image
                      class="reply_img"
                      :src="imgPath('reply_icon.png')"
                    ></el-image>
                    <div
                      class="reply_text cursor_pointer"
                      @click="addReply(sitem.replyId, 3)"
                    >
                      回复
                    </div>
                    <div class="split_line"></div>
                    <el-image
                      class="reply_img cursor_pointer"
                      :src="imgPath('like_icon.png')"
                      v-if="!sitem.isLiked"
                      @click="evaluateReplyLike(sitem.replyId, index, sindex)"
                    ></el-image>
                    <el-image
                      class="reply_img cursor_pointer"
                      :src="imgPath('liked_icon.png')"
                      @click="evaluateReplyLike(sitem.replyId, index, sindex)"
                      v-else
                    ></el-image>
                    <div class="reply_text">{{ sitem.likeNum }}</div>
                  </div>
                </div>
              </div>
              <div v-if="groupPageSize <= item.subEvaluateList?.length">
                <div
                  class="mar_top_10 flex Flexalign cursor_pointer"
                  @click="getMoreSubEvaluate(item)"
                  v-if="item.subEvaluateList[0].totalNum != item.subEvaluateList?.length"
                >
                  查看剩余回复
                  <el-icon>
                    <ArrowDown />
                  </el-icon>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          class="pagination_box mar_top_10 flex FlexjustifyEnd"
          v-if="isExpanded && listTotal > listQuery.pageSize"
        >
          <el-pagination
            background
            layout="prev, pager, next"
            :total="listTotal"
            @current-change="handleCurrentChange"
          />
        </div>
      </div>
      <div v-else>
        <moe-empty url="moe_empty_bg_img.png" emptyText="暂无评价"></moe-empty>
      </div>
    </div>
    <div
      class="more_load flex Flexalign Flexjustify cursor_pointer"
      v-if="showLoadMore && listTotal"
      @click="toggleExpand"
    >
      {{ isExpanded ? "收起" : "加载更多" }}
      <el-icon>
        <ArrowDown />
      </el-icon>
    </div>
    <learningEvaluate
      ref="learningEvaluate"
      @refreshGetList="getEvaluateList"
    ></learningEvaluate>
    <evaluateReply ref="evaluateReply" @refreshGetList="getEvaluateList"></evaluateReply>
  </div>
</template>

<script>
import learningEvaluate from "@/components/popup/learningEvaluate.vue";
import evaluateReply from "@/components/popup/evaluateReply.vue";
export default {
  name: "GjkcH5EvaluateList",
  props: {
    courseId: {},
    courseDetail: {},
  },
  components: {
    learningEvaluate,
    evaluateReply,
  },

  data() {
    return {
      isExpanded: false,
      showLoadMore: false,
      evaluateInfo: {
        rate: 0,
        numbers: 0,
        evaluateable: true,
      },
      evaluateList: [],
      listQuery: {
        page: 1,
        pageSize: 10,
        courseId: "",
      },
      groupPageSize: 3,
      listTotal: "",
    };
  },
  mounted() {
    if (this.courseId) {
      this.listQuery.courseId = this.courseId;
      this.getEvaluateList();
    }
    // setTimeout(() => {
    //   this.checkOverflow();
    // }, 500);
  },

  methods: {
    checkOverflow() {
      if (!this.$refs.content) return;
      this.$nextTick(() => {
        console.log(this.$refs.content.scrollHeight > this.$refs.content.clientHeight);
      });
      this.showLoadMore =
        this.$refs.content.scrollHeight > this.$refs.content.clientHeight;
      // return this.showLoadMore;
    },
    toggleExpand() {
      this.isExpanded = !this.isExpanded;
    },
    handleCurrentChange(value) {
      this.listQuery.page = value;
      this.getEvaluateList();
    },
    // 评价列表
    getEvaluateList() {
      this.$Api.course
        .getEvaluateList(this.listQuery)
        .then(async (res) => {
          let list = res.data.data.list;
          // 没有数据不在请求接口了
          if (!res.data.data.list?.length) return;
          for (const item of list) {
            item.score = this.$Tools.scoreToStar(item.score);
            item.isLiked = false;
            item.isFirstLoad = true; // 用于判断加载回复接口（为true则将初始的subEvaluateList置空，采用分页的接口获取数据填充，每点击一次页码+1）
            item.pageSize = 10; // 用于查询回复接口（分页）
            item.page = 1;
            // 使用 await 等待异步结果
            // item.subEvaluateList = await this.getReplyList({
            //   courseId: this.courseId,
            //   scene: 1,
            //   sceneIds: item.appraiseId,
            //   groupPageSize: this.groupPageSize,
            // });
            item.subEvaluateList = [];
          }
          this.evaluateList = list;
          this.listTotal = res.data.data.total ? Number(res.data.data.total) : 0;
          this.evaluateInfo.rate = this.$Tools.scoreToStar(
            this.courseDetail.courseExtra.appraiseScore
          );
          this.checkIsLike(); // 评价是否点赞
          this.getReplyListBySize(); // 获取评价下的回复
          this.checkReplyIsLike(); // 回复是否点赞
          setTimeout(() => {
            this.checkOverflow();
          }, 500);
        })
        .catch((err) => {
          // this.$Dialog.toast(err.message, { type: "error" });
          console.log(err);
        });
    },
    getMoreSubEvaluate(info) {
      if (!info.isFirstLoad) {
        ++info.page;
      }
      let listQuery = {
        page: info.page,
        pageSize: info.pageSize,
        courseId: this.courseId,
        scene: 1, // 场景：1评价，2讨论组
        sceneId: info.appraiseId,
        lteCreateTime: info.subEvaluateList[0].createTime,
      };
      this.$Api.course
        .getReplyList(listQuery)
        .then((res) => {
          // 第一次查询回复列表限制了条数，后面每次点击查询更多调用分页接口查询
          if (info.isFirstLoad) {
            info.subEvaluateList = res.data.data.list;
            info.isFirstLoad = false;
          } else {
            info.subEvaluateList = [...info.subEvaluateList, ...res.data.data.list];
          }
          // 加个字段用于判断当前回复数是否已加载完（用于是否展示加载剩余回复字样）
          info.subEvaluateList.forEach((item) => {
            item.totalNum = res.data.data.total;
          });
          this.checkReplyIsLike(); // 回复是否点赞
        })
        .catch((err) => {
          // this.$Dialog.toast(err.message, { type: "error" });
          console.log(err);
        });
    },
    goEvaluate() {
      this.$refs.learningEvaluate.learningEvaluateShow = true;
      this.$refs.learningEvaluate.evaluateInfo.courseId = this.courseId;
      this.$refs.learningEvaluate.evaluateInfo.score = "";
      this.$refs.learningEvaluate.evaluateInfo.content = "";
      this.$refs.learningEvaluate.evaluateInfo.imgs = "";
      this.$refs.learningEvaluate.rateValue = 0;
    },
    // 获取回复信息
    async getReplyListBySize() {
      // try {
      //   const res = await this.$Api.course.getReplyListBySize(params);
      //   return res.data.data; // 直接返回解析后的数据
      // } catch (error) {
      //   console.error(error);
      //   return []; // 错误时返回空数组
      // }
      let listQuery = {
        courseId: this.courseId,
        scene: 1,
        sceneIds: "",
        groupPageSize: this.groupPageSize,
      };
      // 参数合集，查所有评价列表的回复
      this.evaluateList.forEach((item) => {
        listQuery.sceneIds += item.appraiseId + ",";
      });
      this.$Api.course
        .getReplyListBySize(listQuery)
        .then((res) => {
          // 遍历出对应评价的回复
          res.data.data.forEach((item) => {
            let findIndex = this.evaluateList.findIndex(
              (sitem) => sitem.appraiseId == item.sceneId
            );
            if (findIndex != -1) {
              this.evaluateList[findIndex].subEvaluateList.push(item);
            }
          });
        })
        .catch((err) => {
          // this.$Dialog.toast(err.message, { type: "error" });
          console.log(err);
        });
    },
    // 评价点赞
    evaluateLike(id, index) {
      let query = {
        courseId: this.courseId,
        scene: 1, // 1=评价 2=讨论组 3=回复
        sceneId: id, //评价ID、讨论组主题ID、回复ID
      };
      this.$Api.course
        .evaluateLike(query)
        .then((res) => {
          console.log(res);
          if (this.evaluateList[index].isLiked) {
            this.evaluateList[index].likeNum--;
          } else {
            this.evaluateList[index].likeNum++;
          }
          this.evaluateList[index].isLiked = !this.evaluateList[index].isLiked;
          // this.evaluateList = [];
          // this.getEvaluateList();
        })
        .catch((err) => {
          // this.$Dialog.toast(err.message, { type: "error" });
          console.log(err);
        });
    },
    // 评价回复点赞
    evaluateReplyLike(id, index, sindex) {
      let query = {
        courseId: this.courseId,
        scene: 3, // 1=评价 2=讨论组 3=回复
        sceneId: id, //评价ID、讨论组主题ID、回复ID
      };
      this.$Api.course
        .evaluateLike(query)
        .then((res) => {
          console.log(res);
          if (this.evaluateList[index].subEvaluateList[sindex].isLiked) {
            this.evaluateList[index].subEvaluateList[sindex].likeNum--;
          } else {
            this.evaluateList[index].subEvaluateList[sindex].likeNum++;
          }
          this.evaluateList[index].subEvaluateList[sindex].isLiked = !this.evaluateList[
            index
          ].subEvaluateList[sindex].isLiked;
          // this.evaluateList = [];
          // this.getEvaluateList();
        })
        .catch((err) => {
          // this.$Dialog.toast(err.message, { type: "error" });
          console.log(err);
        });
    },
    // 判断是否点赞（评价）
    checkIsLike() {
      let listQuery = {
        courseId: this.courseId,
        scene: 1,
        sceneIds: "",
      };
      this.evaluateList.forEach((item) => {
        listQuery.sceneIds += item.appraiseId + ",";
      });
      if (!listQuery.sceneIds) return;
      this.$Api.course
        .checkIsLike(listQuery)
        .then((res) => {
          this.evaluateList.forEach((item) => {
            let currentIndex = res.data.data.findIndex(
              (sitem) => sitem == item.appraiseId
            );
            if (currentIndex != -1) item.isLiked = true;
          });
        })
        .catch((err) => {
          // this.$Dialog.toast(err.message, { type: "error" });
          console.log(err);
        });
    },
    // 判断是否点赞（评价回复）
    checkReplyIsLike() {
      let listQuery = {
        courseId: this.courseId,
        scene: 3,
        sceneIds: "",
      };
      this.evaluateList.forEach((item) => {
        item.subEvaluateList.forEach((sitem) => {
          listQuery.sceneIds += sitem.replyId + ",";
        });
      });
      if (!listQuery.sceneIds) return;
      this.$Api.course.checkIsLike(listQuery).then((res) => {
        this.evaluateList.forEach((item) => {
          item.subEvaluateList.forEach((sitem) => {
            let currentIndex = res.data.data.findIndex(
              (ssitem) => ssitem == sitem.replyId
            );
            if (currentIndex != -1) sitem.isLiked = true;
          });
        });
      });
    },
    // 回复评价
    addReply(sceneId, scene) {
      this.$refs.evaluateReply.learningEvaluateShow = true;
      this.$refs.evaluateReply.evaluateInfo.sceneId = sceneId;
      this.$refs.evaluateReply.evaluateInfo.scene = scene;
    },
  },
};
</script>
<style lang="scss" scoped>
.course_introduce {
  // max-height: 550px;
  // overflow: hidden;
  position: relative;

  .course_introduce_content {
    .evaluate_info {
      .evaluate_info_left {
        padding-left: 20px;

        .evaluate_rate {
          // font-weight: bold;
          font-size: 48px;
          color: #ff6619;
        }

        .evaluate_rate_box {
          margin-left: 10px;
          color: #999999;

          :deep(.el-rate .el-rate__icon) {
            margin: 0;
          }

          :deep(.el-rate .el-rate__icon) {
            font-size: 26px;
          }
        }
      }

      .btn_evaluate {
        width: 90px;
        height: 32px;
        background: linear-gradient(90deg, #00d5c2, #00d498);
        border-radius: 16px;
        color: #ffffff;
        text-align: center;
        line-height: 32px;
      }
    }

    .evaluate_list {
      .evaluate_one {
        margin-top: 10px;

        .evaluate_one_left {
          .avatar {
            width: 48px;
            height: 48px;
          }
        }

        .evaluate_one_right {
          margin-left: 13px;
          color: rgba(153, 153, 153, 1);

          .evaluate_rate {
            :deep(.el-rate .el-rate__icon) {
              margin: 0;
            }

            margin-left: 13px;
          }

          .evaluate_content {
            margin-top: 5px;
            // font-weight: 600;
            color: #333333;
          }

          .evaluate_time {
            width: 100%;
            color: #999999;
            margin-top: 15px;

            .reply_box {
              .reply_img {
                width: 24px;
                height: 24px;
              }

              .split_line {
                margin: 0 12px;
                width: 1px;
                height: 20px;
                background: #141414;
                opacity: 0.1;
              }

              .reply_text {
                margin-left: 6px;
              }
            }
          }

          .reply_info {
            margin-top: 10px;

            .avatar {
              width: 24px;
              height: 24px;
            }

            .replyer_name {
              margin-left: 8px;
            }
            .replyer_tag {
              width: 32px;
              margin-left: 5px;
              height: 16px;
              background: #ffb200;
              border-radius: 4px;
              font-size: 10px;
              color: #ffffff;
              line-height: 16px;
              text-align: center;
            }

            .reply_text {
              margin-left: 10px;
              color: #333333;
              // font-weight: 600;
            }
          }

          .reply_evaluate_content {
            margin-top: 10px;
          }

          .reply_evaluate_time {
            margin-top: 10px;
          }
        }
      }
    }
  }

  .course_introduce_content.expanded {
    max-height: none;
    overflow: visible;
    /* 展开后高度 */
  }

  .course_introduce_content.not_expanded {
    max-height: 500px;
    overflow: hidden;
  }

  .more_load {
    width: 100%;
    height: 50px;
    background: #ffffff;
    border-radius: 0px 0px 20px 20px;
    // position: absolute;
    // bottom: 0;
    z-index: 9;
    color: #999999;
  }
}
</style>
